module.exports = __webpack_public_path__ + "static/media/bus_stop_icon_highlight.1d20494f.svg";